<template>
  <v-container class="video-view pt-md-16 pt-lg-8">
    <v-row no-gutters>
      <v-col
        :cols="6"
        :lg="2"
        :md="4"
        :sm="12"
        class="text-sm-center text-lg-left text-md-left"
        style="margin: 0px auto;"
      >
        <img
          src="./../assets/eh-av-new.png"
          alt="ERGO Hestia"
          width="100%"
          class="mx-sm-auto mx-md-auto mx-lg-0"
          style="max-width: 200px; margin-left: -23px !important;"
        />
      </v-col>
      <v-spacer />
      <v-col
        class="text-sm-center text-md-right"
        :cols="12"
        :lg="6"
        :md="8"
        :sm="12"
      >
        <!-- <h2>Ubezpieczenie ERGO 4</h2>
        <p>- Twoja perspektywa bezpiecznej przyszłości</p> -->
        <img
          class="pt-lg-8 pt-md-8 mx-sm-auto mx-md-auto"
          src="./../assets/video-lead.png"
          alt="ERGO 4 - Twoja perspektywa bezpiecznej przyszłości"
          width="100%"
          style="max-width: 496px"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <!-- Kliknij, aby zobaczyć film<br />
        przygotowany <strong>specjalnie dla Ciebie.</strong> -->
        <img
          class="pt-8"
          src="./../assets/video-hint.png"
          alt="Film przygotowany specjalnie dla Ciebie"
          width="100%"
          style="max-width: 422px;"
        />
      </v-col>
    </v-row>
    <v-row class="video">
      <v-col :cols="12">
        <video-player
          ref="videoPlayer"
          :options="videoOptions"
          v-if="isPlaylistCreated"
        />
      </v-col>
    </v-row>
    <v-row class="buttons text-right" align="end">
      <v-col>
        <v-btn
          color="white"
          tile
          class="mt-1"
          large
          style="border: 1px solid RGBA(191, 21, 40, 1) !important; text-transform: none; box-shadow: none;"
          @click="copyLink"
        >
          Kopiuj link
        </v-btn>
        <input type="hidden" id="link" :value="link" />
        <v-btn
          color="white"
          tile
          class="ml-2 mt-1"
          large
          v-if="isNavigator"
          style="border: 1px solid RGBA(191, 21, 40, 1) !important; text-transform: none; box-shadow: none;"
          @click="share"
          >Udostępnij film</v-btn
        >
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" bottom>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Zamknij
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import VideoPlayer from "../components/VideoPlayer.vue";

export default {
  name: "Video",
  components: { VideoPlayer },
  data() {
    return {
      isPlaylistCreated: false,
      isNavigator: navigator.share,
      videoList: [
        {
          id: "1",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/9ef3d624-9608-4a69-8d74-f0478dce701b/01_ubez_zycia_nw.ism/manifest(format=m3u8-aapl)",
          name: "01_ubez_zycia_nw"
        },
        {
          id: "2",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/6344851e-95aa-4700-bf6c-e6c2962fc6e8/02_ubez_zycia_kredyt_1920x1080_6.ism/manifest(format=m3u8-aapl)",
          name: "02_ubez_zycia_kredyt"
        },
        {
          id: "3",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/6ebb1fbe-e25d-4b5f-adf7-c122f65fa980/03_ubez_zycia_pelny.ism/manifest(format=m3u8-aapl)",
          name: "03_ubez_zycia_pelny"
        },
        {
          id: "4",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/7502bb78-bf2b-4abe-ae9e-1d4ebd211d72/04_uszkodzenie_ciala_NW.ism/manifest(format=m3u8-aapl)",
          name: "04_uszkodzenie_ciala_NW"
        },
        {
          id: "5",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/ebcb9e8d-0fcc-475c-90aa-ec7bef0be7ce/05_niezdolnosc_pracy_kredyt.ism/manifest(format=m3u8-aapl)",
          name: "05_niezdolnosc_pracy_kredyt"
        },
        {
          id: "6",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/b01afa79-a178-4427-ab8e-d4cadba44b38/06_niezdolnosc_pracy_pelny.ism/manifest(format=m3u8-aapl)",
          name: "06_niezdolnosc_pracy_pelny"
        },
        {
          id: "7",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/33b279b4-919f-413d-8a08-0cb502dc5dbc/07_powazne_zachorowanie_nowotwor.ism/manifest(format=m3u8-aapl)",
          name: "07_powazne_zachorowanie_nowotwor"
        },
        {
          id: "8",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/99cfd155-075d-4c70-a116-32eb5f70d90c/08_powazne_zachorowanie_rozszerz.ism/manifest(format=m3u8-aapl)",
          name: "08_powazne_zachorowanie_rozszerz"
        },
        {
          id: "9",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/cf7d4c79-1e5b-4cba-b94b-d3deb3e89520/09_powazne_zachorowanie_pelny.ism/manifest(format=m3u8-aapl)",
          name: "09_powazne_zachorowanie_pelny"
        },
        {
          id: "a",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/8e1062ef-82e8-4ea0-abd4-ddf131fa992a/10_dziecko_szkodzenie_ciala_NW.ism/manifest(format=m3u8-aapl)",
          name: "10_dziecko_szkodzenie_ciala_NW"
        },
        {
          id: "b",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/3829038e-1c61-45fa-9295-b2576b7d70b9/11_dziecko_powazne_zachorowanie.ism/manifest(format=m3u8-aapl)",
          name: "11_dziecko_powazne_zachorowanie"
        },
        {
          id: "c",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/561fd826-5817-4dff-9ae9-a23ae14259a0/12_dziecko_pelny.ism/manifest(format=m3u8-aapl)",
          name: "12_dziecko_pelny"
        },
        {
          id: "d",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/243475dc-43bf-4017-9a5a-df0add19557c/13_Global_Doctors_podst.ism/manifest(format=m3u8-aapl)",
          name: "13_Global_Doctors_podst"
        },
        {
          id: "e",
          src:
            "https://ofertomatvideo-euno.streaming.media.azure.net/81fc7f62-7c86-4867-845a-3dba8e0375a8/14_Global_Doctors_rozszerzony.ism/manifest(format=m3u8-aapl)",
          name: "14_Global_Doctors_rozszerzony"
        }
      ],
      videoOptions: {
        autoplay: false,
        controls: true,
        preload: "auto",
        fill: "true",
        //responsive: true,
        //fluid: true,
        playlist: [],
        enableLowInitialPlaylist: true
      },
      link: "" + window.location.href,
      snackbar: false,
      snackbarText: ""
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  async mounted() {
    await this.getPlaylist();
  },
  methods: {
    getPlaylist() {
      return new Promise(resolve => {
        let name = "v";

        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(window.location.href);
        if (!results) return null;
        if (!results[2]) return "";
        let ids = decodeURIComponent(results[2].replace(/\+/g, " "));
        ids = ids.toLowerCase();
        ids = ids
          .split("")
          .sort()
          .join("")
          .replaceAll(",", "");
        let videoList = this.videoList.filter(el => {
          return ids.includes(el.id);
        });
        let playlist = videoList.map(el => {
          let source = {
            sources: [
              {
                src: el.src,
                type: "application/x-mpegURL"
              }
            ]
          };
          return source;
        });
        this.videoOptions.playlist = playlist;
        this.videoOptions.playlist.push({
          sources: [
            {
              src:
                "https://ofertomatvideo-euno.streaming.media.azure.net/05d38a2f-1719-4004-84cd-e717b4f7d4d2/15_ofertomat_podsumowanie.ism/manifest(format=m3u8-aapl)",
              type: "application/x-mpegURL"
            }
          ]
        });
        this.isPlaylistCreated = true;
        resolve();
      });
    },
    copyLink() {
      //window.location.href

      let testingCodeToCopy = document.querySelector("#link");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful
          ? "Link skopiowany do schowka"
          : "Nie udało się skopiować linku";

        this.snackbar = true;
        this.snackbarText = msg;
      } catch (err) {
        alert("Niestety nie można skopiować linku");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    share() {
      if (navigator.share) {
        navigator
          .share({
            title: "ERGO4 - Ofertomat Video",
            text: "ERGO4 - Ofertomat Video",
            url: this.link
          })
          .then(() => {
            return;
          })
          .catch(error => {
            console.log("Error sharing", error);
            // this.snackbar = true;
            // this.snackbarText =
            //   "Niestety nie udało się udostępnić. Sprawdź czy komunikujesz się ze stron poprzez HTTPS.";
          });
      } else {
        this.snackbar = true;
        this.snackbarText =
          "Niestety nie udało się udostępnić. Sprawdź czy komunikujesz się ze stron poprzez HTTPS.";
      }
    }
  }
};
</script>

<style lang="scss">
.video {
  height: 60vh;
  border: 1px solid rgb(88, 88, 88);
  width: 100%;
  margin: 0 auto;

  .vjs-big-play-button {
    color: #757575;
    background: none !important;
    border: 3px solid #757575;
    opacity: 0.4;
    width: 300px;
    height: 300px;
    border-radius: 100%;
    transition: all 0.6s;
  }

  .vjs-big-play-button:hover {
    color: #757575;
    background: none !important;
    border: 3px solid #757575;
    opacity: 1;
    width: 300px;
    height: 300px;
    border-radius: 100%;
    transition: all 0.6s;
  }
}

.video-view {
  max-width: 1200px;
  .video .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -8%);
    font-size: 4em;
  }
}

.video .video-js {
  background-color: #fff;
}

.buttons {
  .v-btn__content {
    font-weight: 400;
    letter-spacing: initial;
    font-size: 1.4rem;
    color: #58585a;
  }
}

.video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}
</style>
